import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import newOrleans__asset from "@/assets/restore/locations/new-orleans.jpg.asset.json";

const cities: StateCity[] = [
  {
    name: "New Orleans",
    address: "1615 Poydras St, Suite 900",
    img: newOrleans__asset.url,
    mapUrl:
      "https://www.google.com/maps/search/?api=1&query=1615+Poydras+St+New+Orleans+LA",
    to: "/locations/louisiana/new-orleans/",
  },
];

export const Route = createFileRoute("/locations/louisiana/")({
  head: () => ({
    meta: [
      { title: "Louisiana Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Louisiana. Book a free personal hair loss consultation at our New Orleans location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Louisiana Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in New Orleans, Louisiana and book a free consultation to learn about the FUE procedure.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/louisiana/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/louisiana/" }],
  }),
  component: () => <StateLocationsHub stateName="Louisiana" cities={cities} />,
});